module.exports = __webpack_public_path__ + "img/monitorbox12.6eecac47.jpg";